/**
 * API Utilities — auth headers for server requests.
 */

import { auth } from "./firebase";

/**
 * Return standard headers with a Firebase ID token for authenticated API calls.
 * @returns {Promise<Object>} Headers object with Content-Type and Authorization.
 */
export async function getAuthHeaders() {
  const token = await auth.currentUser?.getIdToken();
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}
